module.exports = __webpack_public_path__ + "static/media/sliderItem2.5db58325.JPG";